interface ActionType {
  GET_ANNOUNCEMENTS_START: string;
  GET_ANNOUNCEMENTS_SUCCESS: string;
  GET_ANNOUNCEMENTS_FAILURE: string;
  GET_LIST_ANNOUNCEMENTS_START: string;
  GET_LIST_ANNOUNCEMENTS_SUCCESS: string;
  GET_LIST_ANNOUNCEMENTS_FAILURE: string;
  REMOVE_ALL_ANNOUNCEMENT: string;
  REMOVE_ANNOUNCEMENT: string;
  HIDE_ANNOUNCEMENT_START: string;
  HIDE_ANNOUNCEMENT_SUCCESS: string;
  HIDE_ANNOUNCEMENT_FAILURE: string;
  UNHIDE_ANNOUNCEMENT_START: string;
  UNHIDE_ANNOUNCEMENT_SUCCESS: string;
  UNHIDE_ANNOUNCEMENT_FAILURE: string;
  DELETE_ANNOUNCEMENT_START: string;
  DELETE_ANNOUNCEMENT_SUCCESS: string;
  DELETE_ANNOUNCEMENT_FAILURE: string;
  UPDATE_ANNOUNCEMENT_START: string;
  UPDATE_ANNOUNCEMENT_SUCCESS: string;
  UPDATE_ANNOUNCEMENT_FAILURE: string;
  ADD_ANNOUNCEMENT_START: string;
  ADD_ANNOUNCEMENT_SUCCESS: string;
  ADD_ANNOUNCEMENT_FAILURE: string;
  HIDE_ANNOUNCEMENT_BULK_START: string;
  HIDE_ANNOUNCEMENT_BULK_SUCCESS: string;
  HIDE_ANNOUNCEMENT_BULK_FAILURE: string;
}

export const AnnouncementActionTypes: ActionType = {
  GET_ANNOUNCEMENTS_START: '@@GET_ANNOUNCEMENTS_START',
  GET_ANNOUNCEMENTS_SUCCESS: '@@GET_ANNOUNCEMENTS_SUCCESS',
  GET_ANNOUNCEMENTS_FAILURE: '@@GET_ANNOUNCEMENTS_FAILURE',
  GET_LIST_ANNOUNCEMENTS_START: '@@GET_LIST_ANNOUNCEMENTS_START',
  GET_LIST_ANNOUNCEMENTS_SUCCESS: '@@GET_LIST_ANNOUNCEMENTS_SUCCESS',
  GET_LIST_ANNOUNCEMENTS_FAILURE: '@@GET_LIST_ANNOUNCEMENTS_FAILURE',
  REMOVE_ALL_ANNOUNCEMENT: '@@REMOVE_ALL_ANNOUNCEMENT',
  REMOVE_ANNOUNCEMENT: '@@REMOVE_ANNOUNCEMENT',
  HIDE_ANNOUNCEMENT_START: '@@HIDE_ANNOUNCEMENT_START',
  HIDE_ANNOUNCEMENT_SUCCESS: '@@HIDE_ANNOUNCEMENT_SUCCESS',
  HIDE_ANNOUNCEMENT_FAILURE: '@@HIDE_ANNOUNCEMENT_FAILURE',
  UNHIDE_ANNOUNCEMENT_START: '@@UNHIDE_ANNOUNCEMENT_START',
  UNHIDE_ANNOUNCEMENT_SUCCESS: '@@UNHIDE_ANNOUNCEMENT_SUCCESS',
  UNHIDE_ANNOUNCEMENT_FAILURE: '@@UNHIDE_ANNOUNCEMENT_FAILURE',
  DELETE_ANNOUNCEMENT_START: '@@DELETE_ANNOUNCEMENT_START',
  DELETE_ANNOUNCEMENT_SUCCESS: '@@DELETE_ANNOUNCEMENT_SUCCESS',
  DELETE_ANNOUNCEMENT_FAILURE: '@@DELETE_ANNOUNCEMENT_FAILURE',
  UPDATE_ANNOUNCEMENT_START: '@@UPDATE_ANNOUNCEMENT_START',
  UPDATE_ANNOUNCEMENT_SUCCESS: '@@UPDATE_ANNOUNCEMENT_SUCCESS',
  UPDATE_ANNOUNCEMENT_FAILURE: '@@UPDATE_ANNOUNCEMENT_FAILURE',
  ADD_ANNOUNCEMENT_START: '@@ADD_ANNOUNCEMENT_START',
  ADD_ANNOUNCEMENT_SUCCESS: '@@ADD_ANNOUNCEMENT_SUCCESS',
  ADD_ANNOUNCEMENT_FAILURE: '@@ADD_ANNOUNCEMENT_FAILURE',
  HIDE_ANNOUNCEMENT_BULK_START: '@@HIDE_ANNOUNCEMENT_BULK_START',
  HIDE_ANNOUNCEMENT_BULK_SUCCESS: '@@HIDE_ANNOUNCEMENT_BULK_SUCCESS',
  HIDE_ANNOUNCEMENT_BULK_FAILURE: '@@HIDE_ANNOUNCEMENT_BULK_FAILURE'
};

export enum ANNOUNCEMENT_CATEGORY {
  IMPORTANT = 'IMPORTANT',
  NOTICE = 'NOTICE',
  INFORMATION = 'INFORMATION'
}

export interface AnnouncementState {
  announcements?: AnnouncementItem[];
  listAnnouncements?: AnnouncementItem[];
  processing?: 'loading' | 'hiding' | 'deleting' | 'updating' | 'adding';
  process?: string;
  submitting?: boolean;
  success?: boolean;
  error?: string;
}

export interface AnnouncementItem {
  id: number;
  targetRoles: string[];
  category: ANNOUNCEMENT_CATEGORY;
  title: string;
  text?: string;
  callToActionLabel?: string;
  callToActionLink?: string;
  icon?: string;
  isUserAbleToHide?: boolean;
  noticeType?: string;
}

export interface AddAnnouncementRequest {
  title: string;
  text: string;
  category: string;
  callToActionLabel: string;
  callToActionLink: string;
  startAt: string;
  endAt: string;
  icon: string;
  isUserAbleToHide: boolean;
  userId: number;
  targetRoles: Array<string>;
  noticeType: string;
  organisations: Array<string>;
}
